export const environment = {
  production: false,
  analyticsUrl: 'http://localhost:3001/analytics',
  ssoUrl: 'https://iam-dev.vanti.tech/login?app_id=6942e3b33c77e78c3249045c',
  apiSSO: 'https://iam-api-dev.vanti.tech',
  // apiUrl: 'https://calentadores-api-dev.vanti.tech/',
  apiUrl: 'https://calentadores-api-dev.vanti.tech/api/v1',
  appId: '6942e3b33c77e78c3249045c',
};
